import { render, staticRenderFns } from "./bairunPayChannel.vue?vue&type=template&id=0b54aed6&"
import script from "./bairunPayChannel.vue?vue&type=script&lang=js&"
export * from "./bairunPayChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b54aed6')) {
      api.createRecord('0b54aed6', component.options)
    } else {
      api.reload('0b54aed6', component.options)
    }
    module.hot.accept("./bairunPayChannel.vue?vue&type=template&id=0b54aed6&", function () {
      api.rerender('0b54aed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/bairunPayChannel/bairunPayChannel.vue"
export default component.exports